import { render, staticRenderFns } from "./Sellers-old.vue?vue&type=template&id=1bb10693&scoped=true&"
import script from "./Sellers-old.vue?vue&type=script&lang=js&"
export * from "./Sellers-old.vue?vue&type=script&lang=js&"
import style0 from "./Sellers-old.vue?vue&type=style&index=0&id=1bb10693&scoped=true&lang=css&"
import style1 from "./Sellers-old.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb10693",
  null
  
)

export default component.exports